import React, { PropTypes } from 'react';
import classnames from 'classnames';
import NegativeFeedback from 'entries/containers/negative_feedback';
import PositiveFeedback from 'entries/containers/positive_feedback';
import Thumbnail from 'common/components/thumbnail';
import { POSITIVE_FEEDBACK_THRESHOLD } from 'entries/constants';

const Feedback = ({ item, feedbackGiven, hideThumbnail }) => {
  const revision = item.revisions[0];

  return (
    <div className="feedback-wrapper">
      <div className="feedback-wrapper-header">
        { revision.score > POSITIVE_FEEDBACK_THRESHOLD?
        <h5>We're glad you like it!</h5> : <h5>Help { item.author_username } improve this entry</h5> }
      </div>
      <div className="feedback-wrapper-content">
        <div className="row">
          { !feedbackGiven?
          <div className={classnames("columns small-16", { "medium-11": !hideThumbnail })}>
            { revision.score > POSITIVE_FEEDBACK_THRESHOLD?
            <PositiveFeedback item={item} /> : <NegativeFeedback item={item} /> }
          </div>:
          <div className={classnames("columns small-16 feedback-send-success text-center", {
            "medium-11": !hideThumbnail
          })}>
            <div>
              <i className="fa fa-check-circle text-success" />
              <h3>Thanks for your feedback!</h3>
            </div>
          </div> }

          { !hideThumbnail &&
          <div className="columns small-16 medium-5 hide-for-small-only">
            <Thumbnail className="entry-thumbnail"
                image={item.entry_type === 'name'? null : revision.thumbnails[0]}>
              { item.entry_type === 'name' && <div className="revision-name">{ revision.name }</div> }
            </Thumbnail>
          </div> }
        </div>
      </div>
    </div>
  );
};

Feedback.propTypes = {
  item: PropTypes.object.isRequired,
  feedbackGiven: PropTypes.bool,
  hideThumbnail: PropTypes.bool,
};

export default Feedback;



// WEBPACK FOOTER //
// ./entries/components/feedback.jsx